import React from 'react';
import { Link } from 'react-router-dom';
import './Shared.css';

export const WHATSAPP_NUMBER = '5531982805782';
export const WHATSAPP_LINK = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}`;

export function RingMark({ className }) {
  return (
    <svg className={className} viewBox="0 0 120 140" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="60" cy="70" r="46" stroke="currentColor" strokeWidth="14" />
      <path d="M78 10 L92 2 L82 32 Z" fill="currentColor" />
      <circle cx="98" cy="42" r="4" fill="currentColor" />
      <circle cx="104" cy="58" r="6" fill="currentColor" />
      <circle cx="104" cy="78" r="8" fill="currentColor" />
    </svg>
  );
}

export function InstagramIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" />
    </svg>
  );
}

export function FacebookIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M13.6 21V13.2H15.9L16.2 10.4H13.6L13.6 8.8C13.6 8 13.8 7.4 15 7.4H16.3V4.9C15.8 4.8 15.1 4.8 14.3 4.8C12.4 4.8 11.1 6 11.1 8.1V10.4H9V13.2H11.1V21"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SectionTitle({ label }) {
  return (
    <div className="section-title">
      <span className="section-title__wedge section-title__wedge--left" aria-hidden="true" />
      <span className="section-title__tab">{label}</span>
      <span className="section-title__wedge section-title__wedge--right" aria-hidden="true" />
    </div>
  );
}

export function SiteHeader() {
  return (
    <header className="site-header">
      <Link to="/">
        <img src={process.env.PUBLIC_URL + '/logo_fragus.png'} className="site-header__logo" alt="Fragus" />
      </Link>
    </header>
  );
}

export function SiteFooter({ children }) {
  return (
    <footer className="site-footer">
      {children}

      <div className="site-footer__social">
        <a
          href="https://instagram.com/fragusoficial"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Fragus no Instagram"
          className="site-footer__social-icon"
        >
          <InstagramIcon />
        </a>
        <a
          href="https://facebook.com/fragusoficial"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Fragus no Facebook"
          className="site-footer__social-icon"
        >
          <FacebookIcon />
        </a>
        <span className="site-footer__social-handle">fragusoficial</span>
      </div>

      <div className="site-footer__logos">
        <img src={process.env.PUBLIC_URL + '/logo_fragus.png'} alt="Fragus" />
      </div>
    </footer>
  );
}
